module.exports = __webpack_public_path__ + "../resources/images/illustration_search-710743f8fd439c504db4d396c5dc51ad.svg";